import { createStore } from 'easy-peasy';
import newsModel from './newsModel';
import videoModel from './videoModel';
import leagueSelectionModel from "./leagueSelectionModel";

const store = createStore({
    news: newsModel,
    video: videoModel,
    leagueSelection: leagueSelectionModel,
});

export default store;
